// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const EnumEntityType = {
  "USER": "USER"
};

const UserStatus = {
  "ACTIVE": "ACTIVE",
  "DEACTIVATED": "DEACTIVATED"
};

const UserRole = {
  "SUPER_ADMIN": "SuperAdmin",
  "ADMIN": "Admin",
  "TECHNICIAN": "Technician",
  "CITIZEN": "Citizen"
};

const StockLocationStatus = {
  "ACTIVE": "ACTIVE",
  "INACTIVE": "INACTIVE",
  "REMOVED": "REMOVED"
};

const CountryCode = {
  "A": "A"
};

const Gender = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "DIVERSE": "DIVERSE",
  "OTHER": "OTHER"
};

const MeteringPointStatus = {
  "ACTIVE": "ACTIVE",
  "REMOVED": "REMOVED"
};

const DeviceStatus = {
  "ACTIVE": "ACTIVE",
  "INACTIVE": "INACTIVE",
  "IN_STOCK": "IN_STOCK",
  "REPLACED": "REPLACED",
  "REMOVED": "REMOVED"
};

const DeviceType = {
  "HRL_C_G3": "HRL_C_G3",
  "CORONA_MV": "CORONA_MV"
};

const PeriodType = {
  "DEVICE_CHANGE": "DEVICE_CHANGE",
  "DEVICE_READING": "DEVICE_READING"
};

const PeriodStatus = {
  "DONE": "DONE",
  "IN_PROGRESS": "IN_PROGRESS",
  "CREATED": "CREATED"
};

const TourStatus = {
  "DONE": "DONE",
  "ACCOMPLISHED_BY_TECHNICIAN": "ACCOMPLISHED_BY_TECHNICIAN",
  "IN_PROGRESS_BY_TECHNICIAN": "IN_PROGRESS_BY_TECHNICIAN",
  "ASSIGNED_TO_TECHNICIAN": "ASSIGNED_TO_TECHNICIAN",
  "PENDING": "PENDING",
  "CREATED": "CREATED"
};

const TourTaskStatus = {
  "DONE": "DONE",
  "NO_CUSTOMER": "NO_CUSTOMER",
  "FURTHER_ACTION": "FURTHER_ACTION",
  "IN_PROGRESS": "IN_PROGRESS",
  "PENDING": "PENDING",
  "CREATED": "CREATED"
};

const TourTaskType = {
  "DEVICE_CHANGE": "DEVICE_CHANGE",
  "DEVICE_READING": "DEVICE_READING"
};

const { User, StockLocation, Customer, Object, MeteringPoint, PeriodMeteringPoint, Device, Period, Tour, TourTask, Image, Address, GeoLocation, S3Object, TBToken } = initSchema(schema);

export {
  User,
  StockLocation,
  Customer,
  Object,
  MeteringPoint,
  PeriodMeteringPoint,
  Device,
  Period,
  Tour,
  TourTask,
  Image,
  EnumEntityType,
  UserStatus,
  UserRole,
  StockLocationStatus,
  CountryCode,
  Gender,
  MeteringPointStatus,
  DeviceStatus,
  DeviceType,
  PeriodType,
  PeriodStatus,
  TourStatus,
  TourTaskStatus,
  TourTaskType,
  Address,
  GeoLocation,
  S3Object,
  TBToken
};